import Modal from '../Modal';

/**
 * Confirms taking a form off its theme.
 *
 * Nothing about how the form looks changes, but from then on edits to the
 * theme no longer reach it, which is easy to miss without being told.
 */
const DetachThemeModal = ({ isOpen, onClose, onConfirm, isSaving }) => {
    return (
        <Modal isOpen={isOpen} onClose={onClose} widthClass="max-w-md">
            <h2 className="text-2xl font-semibold text-center mb-6">
                Detach Theme
            </h2>

            <div className="text-[17px] text-gray-700">
                Keeps this look on the form and stops following the theme.
            </div>

            <div className="flex items-center gap-3 mt-6">
                <button
                    type="button"
                    className="btn-save"
                    onClick={onConfirm}
                    disabled={isSaving}
                >
                    Detach
                </button>
                <button
                    type="button"
                    className="btn-gray-pill-lg"
                    onClick={onClose}
                    disabled={isSaving}
                >
                    Cancel
                </button>
            </div>
        </Modal>
    );
};

export default DetachThemeModal;
